/* eslint-disable no-useless-escape */
/* eslint-disable no-redeclare */
import Gikam from "./gikam-core";

export default {

    notEmpty: function (value) {
        if (Gikam.isEmpty(value, true) || value === '') {
            return {
                result: false,
                message: Gikam.propI18N('GIKAM.VALIDATOR.REQUIRED')
            };
        } else {
            return {
                result: true
            };
        }
    },

    strLength: function (v, rule) {
        if (Gikam.isEmpty(v)) {
            return {result: true}
        }
        var numArray = rule.split(','), min = numArray[0], max = numArray[1], minr, maxr, reg = /\(|\)|\[|\]/g,
            minValue = min.replace(reg, ''), maxValue = max.replace(reg, ''),
            value = Gikam.isEmpty(v) ? '' : v.toString(),
            minMessage = min.indexOf('[') === 0 ? '大于等于' : '大于', maxMessage = max.substr(-1) === ']' ? '小于等于' : '小于',
            r = {message: '请填写长度在' + minValue + '于' + maxValue + '之间的字符'},
            minr = min.indexOf('(') >= 0 ? (value.length > minValue ? true : false) : (value.length >= minValue ? true : false),
            maxr = max.substr(-1) === ')' ? (value.length < maxValue ? true : false) : (value.length <= maxValue ? true : false);
        if (Gikam.isEmpty(minValue)) {
            maxr === true ? r.result = true : (r.result = false, r.message = '请填写长度' + maxMessage + maxValue + '的字符');
        } else if (Gikam.isEmpty(maxValue)) {
            minr === true ? r.result = true : (r.result = false, r.message = '请填写长度' + minMessage + minValue + '的字符');
        } else {
            (minr === true && maxr === true) ? r.result = true : r.result = false;
        }
        return r;
    },

    numRange: function (value, rule) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        var numArray = rule.split(','), min = numArray[0], max = numArray[1], minr, maxr, reg = /\(|\)|\[|\]/g,
            minStr = min.replace(reg, ''), maxStr = max.replace(reg, ''),
            minValue = Gikam.isEmpty(minStr) ? null : ~~minStr, maxValue = Gikam.isEmpty(maxStr) ? null : ~~maxStr,
            value = ~~value,
            minMessage = min.indexOf('[') === 0 ? '大于等于' : '大于', maxMessage = max.substr(-1) === ']' ? '小于等于' : '小于',
            r = {message: '请填写' + minMessage + minValue + '并' + maxMessage + maxValue + '的数字'},
            minr = min.indexOf('(') >= 0 ? (value > minValue ? true : false) : (value >= minValue ? true : false),
            maxr = max.substr(-1) === ')' ? (value < maxValue ? true : false) : (value <= maxValue ? true : false);
        if (Gikam.isEmpty(minStr)) {
            (Gikam.isNumber(maxValue) && maxr === true) ? r.result = true : (r.result = false, r.message = '请填写' + maxMessage + maxValue + '的数字');
        } else if (Gikam.isEmpty(maxStr)) {
            (Gikam.isNumber(minValue) && minr === true) ? r.result = true : (r.result = false, r.message = '请填写' + minMessage + minValue + '的数字');
        } else {
            (Gikam.isNumber(minValue) && Gikam.isNumber(maxValue) && minr === true && maxr === true) ? r.result = true : r.result = false;
        }
        return r;
    },

    number: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        return (!isNaN(parseFloat(value)) && isFinite(value)) ? {result: true} : {result: false, message: '请填写数字'};
    },

    phone: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        if ((/^((00|\+)?(86(?:-| )))?((\d{11})|(\d{3}[- ]{1}\d{4}[- ]{1}\d{4})|((\d{2,4}[- ]){1}(\d{7,8}|(\d{3,4}[- ]{1}\d{4}))([- ]{1}\d{1,4})?))$/).test(value)) {
            return {
                result: true
            };
        } else {
            return {
                result: false,
                message: '请填写正确的座机或手机号码'
            };
        }
    },

    email: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        if ((/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/).test(value)) {
            return {
                result: true
            };
        } else {
            return {
                result: false,
                message: '请填写正确的电子邮箱地址'
            };
        }
    },

    remote: function (value, url, field, idValue) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        if (field !== 'id') {
            url += '/' + field + '/' + value;
        }
        var result = {
            result: false,
            message: '内容已存在，请重新填写'
        };
        Gikam.postSync(Gikam.printf(url, {id: Gikam.isEmpty(idValue) ? value : idValue})).done(function (r) {
            result.result = r.valid;
            if (r.message) {
                result.message = r.message;
            }
        });
        return result;
    },

    ip: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        if (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value)) {
            return {
                result: true
            };
        } else {
            return {
                result: false,
                message: '请填写正确格式的IP地址'
            };
        }
    },

    integer: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }
        if (/^([+-])?\d+$/.test(value)) {
            return {
                result: true
            };
        } else {
            return {
                result: false,
                message: Gikam.propI18N('GIKAM.VALIDATOR.INTEGER')
            };
        }
    },

    uppercase: function (value) {
        if (Gikam.isEmpty(value)) {
            return {result: true}
        }

        if (/^[A-Z]+$/.test(value)) {
            return {
                result: true
            };
        } else {
            return {
                result: false,
                message: Gikam.propI18N('GIKAM.VALIDATOR.UPPERCASE')
            };
        }
    }
}

